module.exports = __webpack_public_path__ + "static/media/play-player-lose.f31dfb91.png";